import Vue from 'vue';
import Router from 'vue-router';

export default () => {
  Vue.use(Router);

  const router = new Router({
    mode: 'history',
    base: '/ics/property/agent',
    routes: [
      {
        name: 'agentList',
        path: '/:p1(industrial|office|shops)?',
        props: route => ({
          queryKeyword: route.query,
        }),
        component: () => import('./search'),
      },
      {
        name: 'agentDetail',
        path: '/:emailAlias',
        component: () => import('./detail'),
      },

    ],
    scrollBehavior() {
      return { x: 0, y: 0 };
    },
  });
  return router;
};
